import { render, staticRenderFns } from "./imagen.vue?vue&type=template&id=632e8f7d&scoped=true"
import script from "./imagen.vue?vue&type=script&lang=js"
export * from "./imagen.vue?vue&type=script&lang=js"
import style0 from "./imagen.vue?vue&type=style&index=0&id=632e8f7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632e8f7d",
  null
  
)

export default component.exports